<template>
  <Transition
    name="overlay"
    appear
  >
    <div
      class="dialog-overlay"
      v-if="show"
    />
  </Transition>
  <Transition
    name="dialog"
    appear
  >
    <div
      class="dialog"
      v-if="show"
    >
      <div class="coupon-dialog">
        <div
          class="coupon-dialog__cart"
          @click="toCartPage"
        />
        <div
          class="coupon-dialog__button"
          @click="show = false"
        />
        <p class="coupon-dialog__valid">
          End in: {{ valid }}
        </p>
        <div
          class="coupon-dialog__close"
          @click="show = false"
        />
      </div>
    </div>
  </Transition>
</template>

<script setup>
import dayjs from 'dayjs'
import { formatDate } from '@/utils/utils'

const router = useRouter()

const show = defineModel('show', {
  type: Boolean
})

const valid = computed(() => {
  return formatDate(dayjs().add(3, 'day'))
})

const toCartPage = () => {
  router.push('/carts')
  show.value = false
}
</script>

<style lang="less" scoped>
.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20000;

  &-overlay {
    z-index: 20000;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 20000;
    background: rgba(0, 0, 0, 0.64);
    backdrop-filter: blur(8px);
  }
}

.coupon-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 670px;
  height: 670px;
  background: url('https://cdn-image.bestdealer.com/app-bestdealer/1688/coupon/new-user-coupon-3.png') no-repeat center / cover;

  &__cart, &__button, &__close, &__valid {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }

  &__cart {
    top: 400px;
    height: 16px;
    width: 196px;
  }

  &__button {
    top: 478px;
    height: 48px;
    width: 281px;
  }

  &__valid {
    top: 550px;
    font-family: mon-500;
    font-size: 12px;
    color: #EFF4FD;
  }

  &__close {
    top: 594px;
    width: 24px;
    height: 24px;
  }
}

.overlay-enter-active,
.overlay-leave-active {
  transition: opacity 0.3s ease;
  transition-delay: 0.1s;
}
.overlay-enter-from,
.overlay-leave-to {
  opacity: 0;
}
.dialog-enter-active {
  animation: bounce-in 0.2s ease-in;
}
.dialog-leave-active {
  animation: bounce-in 0.2s reverse;
}
@keyframes bounce-in {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
